import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {setSelectedBan} from './UpdateMailingMethodSlice';
import Loader from '../../Shared/LocalLoader/LocalLoader';
import {saveToHistory, setCurrentStep} from './UpdateMailingMethodSlice';
import {stepEnum,getMailingAdress} from './Constant';
import Checkbox from '../../Shared/CheckBox/Checkbox';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import { dwhMailingMethod } from './dwhReport';
import { gaSelectInvoice ,gaSelectInvoiceContinueButton } from './gaReports';

function BanSelection(props) {

const handleSubmit=(e)=>{
  gaSelectInvoiceContinueButton( props.selectedBan.join(';') , e.currentTarget.textContent);
  if(props.selectedBan.length>0){
        dwhMailingMethod({
          ...props.dwhParams ,
          status: 'Ongoing',
          message:'ban selection screen button clicked',
          ban: props.selectedBan.join(';'),
        })
        props.setCurrentStep(stepEnum.UPDATE_MAILING_METHOD);
    }
  }
  return (
    <div>
      <div className='header'>
        <p className='title'>{props.content.mainTitleBanSelection.value}</p>
        <p className='bold-text'>{props.content.secondaryTitleBanSelection.value}</p>
      </div>
      {props.isLoading ? (
        <Loader />
      ) : (
        <>
          <div className='ban-container'>
            {props.bansInfo.map((item) => {
              const banId = item.ban;
              return (
                <div
                  key={banId}
                  className={`ban-item ${props.selectedBan.includes(banId) ? 'active' : ''}  ${!item.canUpdate ? 'disable' : ''} `}>
                  {item.canUpdate ? (
                    <Checkbox
                      id={banId}
                      onCheck={() => {props.setSelectedBan([...props.selectedBan, banId]); gaSelectInvoice(banId)}
                      }
                      onUncheck={() => {
                        props.setSelectedBan(props.selectedBan.filter((ban) => ban != banId));
                      }}
                      checked={props.selectedBan.includes(banId)}
                    />
                  ) : (
                    <Image className='alert-icon' src={require('./icons/alert.svg')} />
                  )}
                  <div className='description'>
                    <span className='product'>חשבון {item.productDescription.description}</span>
                    <span className='mailingAdress'>החשבונית נשלחת ל: {getMailingAdress(item)}</span>
                    {!item.canUpdate && <span className='alert-txt'>לא ניתן לעדכן כתובת לחשבונית זו</span>}
                  </div>
                </div>
              );
            })}

            </div>
            <div className='btn-container'>
                <span className={`text ${props.selectedBan.length>0 ? 'd-none': 'd-block'}`}>  כדי להמשיך יש לבחור חשבונית </span>
                  <BtnSubmit
                   text='המשך'
                    onclick={(e) => handleSubmit(e)}
                />
            </div>
        </>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  bansInfo: state.updateMailingMethod.bansInfo,
  isLoading: state.updateMailingMethod.isLoading,
  selectedBan: state.updateMailingMethod.selectedBan,
  dwhParams : state.updateMailingMethod.dwhParams,
});

const mapDispatchToProps = {
  setSelectedBan,
  saveToHistory,
  setCurrentStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(BanSelection);
